/**
 * @generated SignedSource<<3b0d9a2162484b9b5adc84a68c84e649>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BillingFrequency = "MONTHLY" | "ONE_TIME" | "YEARLY";
import { FragmentRefs } from "relay-runtime";
export type useGetPriceMap_memberPackage$data = {
  readonly package: {
    readonly billingOptions: ReadonlyArray<{
      readonly billingCharges: ReadonlyArray<{
        readonly frequency: BillingFrequency;
        readonly squareVariation: {
          readonly amount: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly " $fragmentType": "useGetPriceMap_memberPackage";
};
export type useGetPriceMap_memberPackage$key = {
  readonly " $data"?: useGetPriceMap_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetPriceMap_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetPriceMap_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingOption",
          "kind": "LinkedField",
          "name": "billingOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BillingCharge",
              "kind": "LinkedField",
              "name": "billingCharges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "frequency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SquareItemVariation",
                  "kind": "LinkedField",
                  "name": "squareVariation",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "87f1585b75d6b981377144bc1c623a73";

export default node;
